module.exports = __webpack_public_path__ + "static/mahh-logo-black-bg-192-afa3a0d27c90a6cb2fa884284c06f063.jpg";